import React, { LegacyRef } from 'react'
import './SecondaryButton.scss'
import classNames from 'classnames'

interface SecondaryButtonPorps {
  onKeyDown?: (e: React.KeyboardEvent) => void
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  children: React.ReactNode
  buttonRef?: LegacyRef<HTMLButtonElement>
  onFocusDown?: boolean
  onFocusUp?: boolean
  className?: string
  id?: string
  disabled?: boolean
}

export const SecondaryButton = ({
  onClick,
  children,
  buttonRef,
  onKeyDown,
  onFocusDown,
  onFocusUp,
  className,
  id,
  disabled,
}: SecondaryButtonPorps) => {
  return (
    <button
      className={classNames('secondary-button', 'focusable', className)}
      id={id}
      onClick={onClick}
      onKeyDown={onKeyDown}
      ref={buttonRef}
      data-sn-down={onFocusDown && ''}
      data-sn-up={onFocusUp && ''}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
